export const defaultColDef = {
    flex: 1,
    filter: false,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    minWidth: 150,
    floatingFilter: false,
    suppressHeaderMenuButton: true,
    sortable: false,
    // Performance optimizations for large datasets
    suppressKeyboardEvent: () => false,
    suppressMovable: true,
};

export const CampaignTableAgGridV1ColumnDefs = [
    {
        headerName: "SOURCE",
        field: "source",
        resizable: true,
        minWidth: 120,
        wrapText: true,
        autoHeight: true,
        flex: 1,
        filter: false,
        floatingFilter: false,
        suppressFloatingFilterButton: false,
        valueFormatter: params => {
            if (!params?.value) return '';
            return params.value?.charAt(0)?.toUpperCase() + params.value?.slice(1);
        },
    },
    {
        headerName: "START DATE",
        field: "startDate",
        resizable: true,
        minWidth: 120,
        wrapText: true,
        autoHeight: true,
        flex: 1,
        filter: false,
        floatingFilter: false,
        valueFormatter: params => {
            if (!params.value) return '';
            const date = new Date(params.value);
            if (isNaN(date)) return params.value;
            return date.toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            });
        },
        suppressFloatingFilterButton: false,
    },
    {
        headerName: "END DATE",
        field: "endDate",
        resizable: true,
        minWidth: 120,
        wrapText: true,
        autoHeight: true,
        flex: 1,
        filter: false,
        floatingFilter: false,
        valueFormatter: params => {
            if (!params.value) return '';
            const date = new Date(params.value);
            if (isNaN(date)) return params.value;
            return date.toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            });
        },
        suppressFloatingFilterButton: false,
    },
    {
        headerName: "CHANNELS",
        field: "channels",
        resizable: true,
        minWidth: 250,
        wrapText: true,
        autoHeight: true,
        flex: 1,
        filter: false,
        floatingFilter: false,
        valueFormatter: params => {
            if (!Array.isArray(params.value)) return '';
            return params.value
                .map(channel => channel?.channel_display_name)
                .filter(Boolean)
                .join(', ');
        },
        suppressFloatingFilterButton: false,
    },
    {
        headerName: "MOH CLIENT CODE",
        field: "client_code",
        resizable: true,
        minWidth: 120,
        wrapText: true,
        autoHeight: true,
        flex: 1,
        filter: false,
        floatingFilter: false,
        valueFormatter: params => {
            if (Array.isArray(params.value)) {
                // Get unique values and join with comma
                const unique = [...new Set(params.value.filter(Boolean))];
                return unique.join(', ');
            }
            if (typeof params.value === 'string') {
                return params.value;
            }
            return '';
        },
        suppressFloatingFilterButton: false,
    },
    {
        headerName: "PLANIT CLIENT CODE",
        field: "clientid",
        resizable: true,
        minWidth: 120,
        wrapText: true,
        autoHeight: true,
        flex: 1,
        filter: false,
        floatingFilter: false,
        valueFormatter: params => {
            if (Array.isArray(params.value)) {
                // Get unique values and join with comma
                const unique = [...new Set(params.value.filter(Boolean))];
                return unique.join(', ');
            }
            if (typeof params.value === 'string') {
                return params.value;
            }
            return '';
        },
        suppressFloatingFilterButton: false,
    },
    {
        headerName: "PRODUCT CODE",
        field: "productid",
        resizable: true,
        minWidth: 120,
        wrapText: true,
        autoHeight: true,
        flex: 1,
        filter: false,
        floatingFilter: false,
        valueFormatter: params => {
            if (Array.isArray(params.value)) {
                // Get unique values and join with comma
                const unique = [...new Set(params.value.filter(Boolean))];
                return unique.join(', ');
            }
            if (typeof params.value === 'string') {
                return params.value;
            }
            return '';
        },
        suppressFloatingFilterButton: false,
    },
    {
        headerName: "ESTIMATE",
        field: "estimateid",
        resizable: true,
        minWidth: 120,
        wrapText: true,
        autoHeight: true,
        flex: 1,
        filter: false,
        floatingFilter: false,
        valueFormatter: params => {
            if (Array.isArray(params.value)) {
                // Get unique values and join with comma
                const unique = [...new Set(params.value.filter(Boolean))];
                return unique.join(', ');
            }
            if (typeof params.value === 'string') {
                return params.value;
            }
            return '';
        },
        suppressFloatingFilterButton: false,
    },
    {
        headerName: "NET MEDIA",
        field: "netmedia",
        resizable: true,
        minWidth: 150,
        wrapText: true,
        autoHeight: true,
        flex: 1,
        filter: false,
        floatingFilter: false,
        suppressFloatingFilterButton: false,
    },
    {
        headerName: "MEDIAOCEAN ID",
        field: "mediaocean_id",
        resizable: true,
        minWidth: 120,
        wrapText: true,
        autoHeight: true,
        flex: 1,
        filter: false,
        floatingFilter: false,
        suppressFloatingFilterButton: false,
    },
    {
        headerName: "STATUS",
        field: "status",
        resizable: true,
        maxWidth: 140,
        wrapText: true,
        autoHeight: true,
        flex: 1,
        filter: false,
        floatingFilter: false,
        suppressFloatingFilterButton: false,
        pinned: 'right',
    },
    {
        headerName: "ACTIONS",
        field: "actions",
        resizable: true,
        maxWidth: 125,
        wrapText: true,
        autoHeight: true,
        flex: 1,
        filter: false,
        floatingFilter: false,
        suppressFloatingFilterButton: false,
        pinned: 'right',
    }
];